import React from "react";
import { Link } from "react-router-dom";
import { useStores } from "../hooks";
import { useIntl } from "react-intl";

export default function Header() {
  const { formatMessage } = useIntl();
  const { sessionStore } = useStores();
  return (
    <div className="Header">
      <h1>
        <img
          src="/images/logo.png"
          title={formatMessage({ id: "hyvendor.header" })}
          alt={formatMessage({ id: "hyvendor.header" })}
        />
      </h1>
      <h2>{formatMessage({ id: "hyvendor.header" })}</h2>
      <div className="nav">
        {sessionStore.isAdmin && (
          <Link to="/admin/in">
            {formatMessage({ id: "hyvendor.menu.admin" })}
          </Link>
        )}
      </div>
    </div>
  );
}
